import ServicePage from "../components/site/ServicePage";
import { getService } from "../data/site";

const TASKS = [
  "Listing preparation",
  "Decluttering",
  "Home refreshes",
  "Light staging",
  "Move coordination",
  "Packing assistance",
  "Donation runs",
  "New-homeowner concierge welcome",
];

export default function RealtorServices() {
  return (
    <ServicePage
      service={getService("realtor-services")}
      tagline="Your behind-the-scenes partner from listing to close."
      intro="You're juggling showings, sellers, and timelines. We're the calm hands that get a home listing-ready and keep your clients happy — decluttering, refreshing, coordinating moves, and even welcoming new homeowners with a concierge touch that makes you look great."
      tasksTitle="How we support your listings"
      tasks={TASKS}
      quoteHeading="Partner With Us"
    />
  );
}
